"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

const Checkbox = ({
	className,
	checked,
	...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) => (
	<CheckboxPrimitive.Root
		className={cn(
			"peer size-4 shrink-0 rounded-sm border border-gray-900 align-middle data-[state=checked]:border-transparent data-[state=indeterminate]:!border-transparent data-[state=checked]:bg-primary data-[state=indeterminate]:bg-primary data-[state=checked]:text-white data-[state=indeterminate]:text-white disabled:!border-gray-500 disabled:!bg-gray-100 disabled:!text-gray-700 disabled:data-[state=checked]:!border-transparent",
			className
		)}
		checked={checked}
		{...props}
	>
		<CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
			{checked === "indeterminate" ? <Minus className="size-3" /> : <Check className="size-4" />}
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
